import { ConfigProvider, Spin } from "antd";
import React, { useEffect, useState } from "react";
import SignIn from "./Scenes/SignIn";
import Main from "./Scenes/Main";
import { getAuthentication } from "./lib/auth";
import DataProvider, { useUser } from "./DataProvider";

const AppContent: React.FC = () => {
  const { isLogin } = useUser();
  const [isLoadingAuth, setIsLoadingAuth] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      const authToken = getAuthentication();
      if (authToken !== null) {
        setIsLoadingAuth(false);
      } else {
        setIsLoadingAuth(false);
      }
    };
    checkAuth();
  }, []);

  if (isLoadingAuth) {
    return (
      <div className="loading-screen h-screen flex items-center justify-center">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <main className="app bg-gradient-to-r from-slate-100 to-blue-100">
      {isLogin ? <Main /> : <SignIn />}
    </main>
  );
};

const App: React.FC = () => {
  return (
    <DataProvider>
      <React.Suspense
        fallback={
          <div className="loading-screen h-screen flex items-center justify-center">
            <Spin size="large" />
          </div>
        }
      >
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: "#29b457",
            },
          }}
        >
          <AppContent />
        </ConfigProvider>
      </React.Suspense>
    </DataProvider>
  );
};

export default App;
